import { useState } from 'react';

import { ExtractionWarning } from '../../types';

import { Item, List, Root, Summary, ToggleButton } from './styles';

interface Props {
  warnings: ExtractionWarning[];
  className?: string;
}

/**
 * What the document reader could not read cleanly: a page it got little text from, a table its
 * two engines read differently, a low OCR score.
 *
 * None of these stops anything, and none of them is a difference between the document and the
 * trade — which is why they sit apart from the findings. They matter because they qualify
 * everything else: a field reported as absent from a page that came back empty is not evidence
 * that the confirmation is silent on it.
 */
const ExtractionWarnings = ({ warnings, className }: Props) => {
  const [expanded, setExpanded] = useState(false);

  if (!warnings.length) return null;

  return (
    <Root className={className}>
      <Summary>
        The document was not read cleanly — {warnings.length} page
        {warnings.length === 1 ? '' : 's'} the reader was unsure about.
      </Summary>
      {expanded && (
        <List>
          {warnings.map((warning, index) => (
            <Item key={`${warning.code}-${warning.page}-${index}`}>
              Page {warning.page} — {warning.message}
            </Item>
          ))}
        </List>
      )}
      <ToggleButton
        type="button"
        onClick={() => setExpanded((shown) => !shown)}>
        {expanded ? 'Hide details' : 'Show details'}
      </ToggleButton>
    </Root>
  );
};

export default ExtractionWarnings;
